import { ActionType, createAsyncAction } from 'typesafe-actions'
import { ChatState } from '../../types'
import { Failure, Success, Request } from './types'

export const setActiveChatAction = createAsyncAction(
  '@chat/SET_ACTIVE_CHAT_REQUEST',
  '@chat/SET_ACTIVE_CHAT_SUCCESS',
  '@chat/SET_ACTIVE_CHAT_FAILURE'
)<Request, Success, Failure>()

const request = (state: ChatState): ChatState => ({ ...state, activeChat: null, isLoadingSetActiveChat: true })

const success = (state: ChatState, action: ActionType<typeof setActiveChatAction.success>): ChatState => ({
  ...state,
  isLoadingSetActiveChat: false,
  isSuccessOnSetActiveChat: true,
  activeChat: action.payload.activeChat,
  infiniteScrollBottomHack: !state.infiniteScrollBottomHack
})

const failure = (state: ChatState): ChatState => ({
  ...state,
  isLoadingSetActiveChat: false,
  isErrorOnSetActiveChat: true
})
export const setActiveChatHandle = { asyncAction: setActiveChatAction, request, success, failure }
